import PropTypes from 'prop-types'

import { DashboardModule, Link, LoadingModule } from '@domain-group/suit-theme'

import useCustomFieldSet from '@hooks/useCustomFieldSet'
import useCustomFieldSets from '@hooks/useCustomFieldSets'

import CustomFieldSet from './CustomFieldSet'

const CustomFieldSets = (props) => {
  const { brandId } = props

  const customFieldSetPayload = useCustomFieldSets({
    filters: { owner_type: 'Brand', owner_id: brandId },
    performHttpRequests: !!brandId,
  })

  const { filteredCustomFieldSets, hasCustomFieldSets, loadingCustomFieldSets } = customFieldSetPayload

  const customFieldPayload = useCustomFieldSet({ entity_type: 'Campaign', owner_id: brandId, owner_type: 'Brand' })
  const { callbacks: { addCustomFieldSet } } = customFieldPayload

  if (loadingCustomFieldSets){
    return <LoadingModule loading={loadingCustomFieldSets} times={3} />
  }

  if (!loadingCustomFieldSets && !hasCustomFieldSets){
    return (
      <DashboardModule title="Custom Field Sets">
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>No Field Sets</DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            <Link onClick={() => addCustomFieldSet()}>Click Here to Add One</Link>
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      </DashboardModule>
    )
  }

  return filteredCustomFieldSets.map(customFieldSet => (
    <CustomFieldSet key={customFieldSet.id} customFieldSet={customFieldSet} />
  ))
}

CustomFieldSets.propTypes = {
  brandId: PropTypes.number.isRequired,
}

export default CustomFieldSets
